export default class ComcheckSerializer {
  static serialize(data) {
    const payload = {
      ...data
    };

    const customProperties = [];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data
    };
  }
}